import moment from 'moment';

const periods = (period) => {
  const dateFormat = 'YYYY-MM-DD';
  let startDate;
  let endDate;
  let error = '';

  switch (period) {
    case 'today': {
      startDate = moment().format(dateFormat);
      endDate = moment().add(1, 'day').format(dateFormat);
      break;
    }
    case 'yesterday': {
      startDate = moment().subtract(1, 'days').format(dateFormat);
      endDate = moment().format(dateFormat);
      break;
    }
    case 'last_week': {
      startDate = moment().subtract(7, 'days').format(dateFormat);
      endDate = moment().format(dateFormat);
      break;
    }
    case 'this_month': {
      startDate = moment().startOf('month').format(dateFormat);
      endDate = moment().endOf('month').format(dateFormat);
      break;
    }
    case 'last_month': {
      const lastMonth = moment().subtract(1, 'month');
      startDate = lastMonth.startOf('month').format(dateFormat);
      endDate = lastMonth.endOf('month').format(dateFormat);
      break;
    }
    default: {
      console.error('Unsupported period.');
      error = 'Unsupported period.';
    }
  }

  return { startDate, endDate, error };
};

export default {
  periods
};



// WEBPACK FOOTER //
// ./src/common/utils/periods.js